<template>
  <div
    v-if="data && data.registro && data.pessoa && data.assinante"
    class="impressao--tamanho_14 impressao--frente">
    <b-container class="impressao_documento--margin">
      <b-row>
        <b-col cols="5"
               class="impressao_documento impressao_documento--qrcode-nascimento">
          <div><u>https://selodigital.tjsp.jus.br</u>.</div>
          <div style="letter-spacing: -1px;">
            Selo Digital: {{ data.selo.selo_digital || "0000000000000000000000000" }}
          </div>
          <div>
            <img :src="qrCodeImg"
                 class="qrcode"
                 alt="">
          </div>
        </b-col>
      </b-row>
      <b-row>
        <div class="impressao_documento impressao_documento--titulo font--18">
          CERTIDÃO DE NASCIMENTO
        </div>
      </b-row>
      <b-row>
        <b-col class="text-center font--12">
          <div class="font--7 bold text-center">
            NOME
          </div>
          <div class="uppercase bold impressao_documento--minus-margin-5">
            {{ data.pessoa.nome || "Não consta" }}
          </div>
        </b-col>
      </b-row>

      <div class="impressao_documento--minus-margin-6">
        <b-row>
          <b-col>
            <fieldset class="fieldset-impressao text-center">
              <legend class="text-center">
                NÚMERO DO CPF
              </legend>
              <span class="bold">{{ data.pessoa.cpf || "NÃO CONSTA" }}</span>
            </fieldset>
          </b-col>
        </b-row>
        <b-row class="mt-1">
          <b-col class="text-center">
            <div class="font--8 bold">
              Matrícula
            </div>
            <div class="bold impressao_documento--minus-margin-5">
              {{ data.registro.matricula | maskMatricula }}
            </div>
          </b-col>
        </b-row>
        <b-row no-gutters>
          <b-col cols="8">
            <fieldset class="fieldset-impressao">
              <legend>
                DATA DE NASCIMENTO
              </legend>
              <span class="bold">{{ data.registro.data_ocorrido.extenso || "Não consta" }}</span>
            </fieldset>
          </b-col>
          <b-col>
            <b-row no-gutters>
              <b-col cols="4">
                <fieldset class="fieldset-impressao ml-2 pl-0 text-center">
                  <legend class="text-center">
                    DIA
                  </legend>
                  <span class="bold">{{
                    (data.registro && data.registro.data_ocorrido.dia) || "N/C"
                  }}</span>
                </fieldset>
              </b-col>
              <b-col cols="4">
                <fieldset class="fieldset-impressao ml-2 pl-0 text-center">
                  <legend class="text-center">
                    MÊS
                  </legend>
                  <span class="bold">{{ data.registro.data_ocorrido.mes || "N/C" }}</span>
                </fieldset>
              </b-col>
              <b-col cols="4">
                <fieldset class="fieldset-impressao ml-2 pl-0 text-center">
                  <legend class="text-center">
                    ANO
                  </legend>
                  <span class="bold">{{ data.registro.data_ocorrido.ano || "N/C" }}</span>
                </fieldset>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
        <b-row no-gutters>
          <b-col cols="3">
            <fieldset class="fieldset-impressao mrpx-5">
              <legend>
                HORÁRIO DE NASCIMENTO
              </legend>
              <span class="bold">{{ data.registro.hora_ocorrido || "Não consta" }}</span>
            </fieldset>
          </b-col>
          <b-col cols="8">
            <fieldset class="fieldset-impressao mlpx-5">
              <legend>
                MUNICÍPIO DA NATURALIDADE
              </legend>
              <span class="bold">{{ data.pessoa.naturalidade || "Não consta" }}</span>
            </fieldset>
          </b-col>
          <b-col cols="1">
            <fieldset class="fieldset-impressao mlpx-5">
              <legend>
                UF
              </legend>
              <span class="bold">{{ data.pessoa.uf || "N/C" }}</span>
            </fieldset>
          </b-col>
        </b-row>
        <b-row no-gutters>
          <b-col cols="5">
            <fieldset class="fieldset-impressao mrpx-5">
              <legend>
                LOCAL DE NASCIMENTO
              </legend>
              <span class="bold">{{ data.registro.local_nascimento || "Não consta" }}</span>
            </fieldset>
          </b-col>
          <b-col cols="4">
            <fieldset class="fieldset-impressao mlpx-5 mrpx-5">
              <legend>
                MUNICÍPIO DE NASCIMENTO
              </legend>
              <span class="bold">{{
                data.registro.local.endereco.cidade || "NÃO CONSTA"
              }}</span>
            </fieldset>
          </b-col>
          <b-col cols="1">
            <fieldset class="fieldset-impressao mlpx-5">
              <legend>
                UF
              </legend>
              <span class="bold">{{ data.registro.local.endereco.uf || "N/C" }}</span>
            </fieldset>
          </b-col>
          <b-col cols="2">
            <fieldset class="fieldset-impressao mlpx-5">
              <legend>
                SEXO
              </legend>
              <span class="bold">{{ data.pessoa.sexo || "Não consta" }}</span>
            </fieldset>
          </b-col>
        </b-row>
        <b-row v-for="(genitor, index) of data.pessoa.genitores"
               :key="index"
               no-gutters>
          <b-col cols="6">
            <fieldset class="genitores fieldset-impressao">
              <legend>
                NOME DO(A) GENITOR(A)
              </legend>
              <span v-html="genitor.nome || 'Não consta'" />
            </fieldset>
          </b-col>
          <b-col cols="5">
            <fieldset class="genitores fieldset-impressao">
              <legend>
                MUNICÍPIO DE NASCIMENTO
              </legend>
              <span v-html="genitor.municipio || 'Não consta'" />
            </fieldset>
          </b-col>
          <b-col cols="1">
            <fieldset class="genitores fieldset-impressao">
              <legend>
                UF
              </legend>
              <span v-html="genitor.uf || 'N/C'" />
            </fieldset>
          </b-col>
          <b-col cols="12"
                 class="mb-2">
            <fieldset class="genitores fieldset-impressao">
              <legend>
                AVÔ(Á)(S) RESPECTIVO(S)
              </legend>
              <span v-html="genitor.avos || 'N/C'" />
            </fieldset>
          </b-col>
        </b-row>

        <b-row v-for="(gemeo, index) in data.pessoa.gemeos"
               :key="`gemeo_${index}`"
               no-gutters>
          <b-col>
            <fieldset v-if="data.pessoa"
                      class="fieldset-impressao">
              <legend>
                GÊMEO
              </legend>
              <div class="bold">
                <div v-if="data.pessoa.gemeos && data.pessoa.gemeos.length > 0">
                  <div v-if="gemeo.nome">
                    {{ gemeo.nome }} - {{ gemeo.matricula || "NÃO CONSTA" }}
                  </div>
                  <div v-else>
                    NÃO CONSTA
                  </div>
                </div>
                <div v-else>
                  NÃO CONSTA
                </div>
              </div>
            </fieldset>
          </b-col>
        </b-row>
        <b-row no-gutters>
          <b-col cols="7">
            <fieldset class="fieldset-impressao">
              <legend>
                DATA DE REGISTRO
              </legend>
              <span class="bold">{{ data.registro.data_registro.extenso || "Não consta" }}</span>
            </fieldset>
          </b-col>
          <b-col>
            <fieldset class="fieldset-impressao ml-2">
              <legend>
                DNV
              </legend>
              <span class="bold">{{ data.dnv || "Não consta" }}</span>
            </fieldset>
          </b-col>
        </b-row>
        <b-row no-gutters>
          <b-col>
            <fieldset class="fieldset-normal">
              <legend>
                ANOTAÇÕES/AVERBAÇÕES
              </legend>
              <span
                v-if="data.averbacao_certidao != null && data.averbacao_certidao.length > 950"
                class="bold text-justify">Vide verso</span>
              <span
                v-if="data.averbacao_certidao != null && data.averbacao_certidao.length <= 950"
                class="text-justify text-break"
                v-html="data.averbacao_certidao || 'Não consta'" />
              <span v-if="data.averbacao_certidao == null"
                    class="bold text-justify">Não consta</span>
            </fieldset>
          </b-col>
        </b-row>
        <b-row no-gutters>
          <b-col>
            <fieldset class="fieldset-impressao">
              <legend>
                ANOTAÇÕES VOLUNTÁRIAS DE CADASTRO
              </legend>
              <span class="bold">{{
                (data.anotacoes.length && "VIDE VERSO.") || "Não consta"
              }}</span>
            </fieldset>
          </b-col>
        </b-row>

        <b-row class="impressao_documento--rodape mt-3 text-center">
          <b-col cols="5"
                 class="font--8 pr-1">
            <div style="white-space: nowrap;">
              Oficial de Registro Civil das Pessoas Naturais
              <br>
              {{ (data.cartorio && data.cartorio.nome) || "Não consta" }} -
              {{
                data.cartorio && data.cartorio.endereco ? data.cartorio.endereco.uf : "Não consta"
              }}
            </div>
            <div class="mt-2">
              {{ data.oficial || "Não consta" }} - Oficial
            </div>
            <div v-if="data.cartorio"
                 class="mt-2">
              {{ (data.cartorio.endereco && data.cartorio.endereco.logradouro) || "Não consta" }},
              nº {{ (data.cartorio.endereco && data.cartorio.endereco.numero) || "Não consta" }} -
              {{ (data.cartorio.endereco && data.cartorio.endereco.bairro) || "Não consta" }} CEP:
              {{ (data.cartorio.endereco && data.cartorio.endereco.cep) || "Não consta" }} - Fone:
              {{ data.cartorio.telefone || "Não consta" }} <br>e-mail:
              {{ data.cartorio.email || "Não consta" }}
            </div>
          </b-col>
          <b-col>
            <div>
              O Conteúdo da certidão é verdadeiro. Dou fé.
            </div>
            <div v-if="data.cartorio">
              {{ (data.cartorio.endereco && data.cartorio.endereco.cidade) || "Não consta" }} -
              {{ (data.cartorio.endereco && data.cartorio.endereco.uf) || "Não consta" }},
              {{ data.data_atual || "Não consta" }}.
            </div>
            <div>
              <hr class="hr--assinatura">
              <div class="d-inline-flex">
                {{ data.assinante.nome || "Não consta" }} -
                {{ data.assinante.cargo || "Não consta" }}
              </div>
            </div>
            <div class="mt-2">
              <div
                v-if="
                  data.emolumentosFiltrados &&
                    !data.emolumentosFiltrados[data.emolumentosFiltrados.length - 1].valor.match(
                      '0,00'
                    )
                ">
                Valor pago por essa certidão:<br>
                <span
                  v-for="(emolumento, index) in data.emolumentosFiltrados"
                  :key="`emolumento_${_uid}_${index}`">
                  <br v-if="emolumento.destino == 'Total' || emolumento.destino == 'AVERBAÇÕES'">
                  <b v-if="emolumento.destino == 'Total'">{{ emolumento.destino }}: {{ emolumento.valor }};</b>
                  <span v-else>{{ emolumento.destino }}: {{ emolumento.valor }};</span>
                </span>
              </div>

              <div
                v-if="
                  !data.emolumentosFiltrados ||
                    !!data.emolumentosFiltrados[data.emolumentosFiltrados.length - 1].valor.match(
                      '0,00'
                    )
                ">
                <b>{{ destino.primeiraVia ? "1ª" : "2ª" }} VIA ISENTA DE EMOLUMENTOS</b>
              </div>
            </div>
          </b-col>
        </b-row>
      </div>
    </b-container>
  </div>
</template>

<script>
/* image */
  import qrCodeImg from "@/assets/img/qrcode.png"

  export default {
    name: "FrenteImpressaoNascimento",
    props: {
      data: Object
    },
    data () {
      return {
        newData: this.data,
        qrCodeImg,
        destino: {
          primeiraVia: false,
          segundaVia: false
        }
      }
    },
    watch: {
      data () {
        this.newData = { ...this.data }

        // Atualiza destino
        this.detino = { primeiraVia: false, segundaVia: false }

        const osSelected = this.data.ordemServicoSelected

        if (!osSelected) return

        // Selecionado o item da OS com o selo selecionado
        const itemOsSelecionado = osSelected.itens.find(itemOS => {
          return itemOS.seloItemOs.find(
            seloItem => seloItem.selo.num_selo === this.data.selo.selo_digital
          )
        })

        // Verifica se o item da OS está com valor zerado
        const osComItemZerado = itemOsSelecionado && itemOsSelecionado.valor === 0

        // Valida OS e com item zerado
        if (
          !osSelected ||
          !osSelected.itens.length ||
          (osSelected.valor_total > 0 && !osComItemZerado)
        )
          return

        const primeiraVia = osSelected.itens.find(
          item => !item.flag_cancelado && (item.custa.codigo === 16 || item.custa.codigo === 19)
        ) // AN e AO

        const segundaVia = osSelected.itens.find(
          item => !item.flag_cancelado && item.custa.codigo !== 16 && item.custa.codigo !== 19
        )

        if (primeiraVia) {
          this.destino = { primeiraVia: true, segundaVia: false }
        } else if (segundaVia) {
          this.destino = { primeiraVia: false, segundaVia: true }
        }
      }
    }
  }
</script>

<style scoped>
.qrcode {
  width: 100px;
}
.genitores {
  font-size: 10px;
  margin-top: 2px;
  padding: 2px 0 3px 0;
  padding-left: 10px;
}
</style>
